type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const TRANSCRIPITON_TODO_HEADERS: Header[] = [
  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "140px" },
    sortable: true,
  },
  {
    key: "qmeDoctorName",
    label: "QME Doctor ",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "caseOrExamType",
    label: "Case / Exam Type",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "dictationId",
    label: "Dictations",
    style: { width: "50px" },
    isNumeric: true,
  },
  {
    key: "transcriptionDueDateDesc",
    label: "Due Date",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "transcriptionStatus",
    label: "Transcription Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "transcriptionFile",
    label: "Transcription",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "appointmentDate",
    label: "Appointment Date & Time",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "locationofAppointment",
    label: "Location",
    style: { width: "250px" },
    sortable: true,
  },
  {
    key: "appointmentStatus",
    label: "Appointment Status",
    style: { width: "200px" },
    sortable: true,
  },

  {
    key: "assignedToUserName",
    label: "Tx Assigned",
    style: { width: "200px" },
    sortable: true,
  },
];
export const EXPORTTRANSCRIPITON_TODO_HEADERS: Header[] = [
  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "140px" },
    sortable: true,
  },
  {
    key: "qmeDoctorName",
    label: "QME Doctor ",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "caseOrExamType",
    label: "Case / Exam Type",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "transcriptionDueDateDesc",
    label: "Due Date",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "transcriptionStatus",
    label: "Transcription Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "transcriptionFile",
    label: "Transcription",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "appointmentDate",
    label: "Appointment Date & Time",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "appointmentStatus",
    label: "Appointment Status",
    style: { width: "200px" },
    sortable: true,
  },

  {
    key: "assignedToUserName",
    label: "Assigned To",
    style: { width: "200px" },
    sortable: true,
  },
];

export const TRANSCRIPITON_LOGS_HEADERS: Header[] = [
  {
    key: "transcriberStatusName",
    label: "Report Status",
  },
  {
    key: "transcriberAssignedUserName",
    label: "Who",
  },
  {
    key: "createdByUserRole",
    label: "Role",
  },
  {
    key: "createdDateNew",
    label: "When",
  },
  {
    key: "transcriberComments",
    label: "Comments",
  },
];
